<template>
  <div>
    <fg-input v-model="item.originalText" :label="$t('replacementRules.originalText')"/>
    <fg-input v-model="item.shortText" :label="$t('replacementRules.shortText')"/>
    <fg-input v-model="item.longText" :label="$t('replacementRules.longText')"/>
    <FormButtons
            @submit="submit"
            :submit="true"   
            :reset="false"
            @remove="remove"
            :remove="action == 'item'" 
            :itemid="item.id+''"
            :modalid="'replacementRuleEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading "/>
  </div>
</template>

<script>
export default {
  name: 'ReplacementRuleForm',
  data: function() {
    return {
      item: {},
      ok: false,
      error: false,
      loading: false
    }
  },
  props: {
    rule: { default: null },
    action: { default: 'new' }
  },
  watch: {
    rule: function( newRule) {
      if( newRule == null )
        this.item = {}
      else
        this.item = { ...newRule }
    }
  },
  methods: {
    remove() {
      if( this.item.id == null || this.item.id==undefined )
        return

      this.startBackendCall()
      this.$store.dispatch('replacementRules/deleteReplacementRule' , this.item.id ).then( () => {
        console.log("Remove OK")
        this.responseOk()
      }).catch( () => {
        console.log("Error in remove")
        this.error = true
      }).finally( () => {
        console.log("Finally set loading to false")
        this.loading = false
      })
    },
    startBackendCall() {
      this.ok = this.error = false;
      this.infoType = "save";
      this.loading = true;
    },
    responseOk() {
      this.ok = false
      this.error = false
    },
    submit() {
      this.startBackendCall()
      const saveItem = { ...this.item }
      delete saveItem.uiType
      this.$store.dispatch('replacementRules/updateReplacementRule' , saveItem).then( () => {
        this.responseOk()
      }).catch( () => {
        this.error = true
      }).finally( () => {
        this.loading = false
      })
    }
  },
  beforeCreate() {
        const replacementRules = () => import('@/store/realtime/replacementRules')
        if( !this.$store.state.replacementRules ) {
            this.$store.registerModule("replacementRules" , replacementRules )
        }
    }
}
</script>

<style>

</style>